import { SubNav } from '@/components/ui/page';

/** Tabs between the messaging subpages (OUT-1…6). */
const MessagingNav = () => (
  <SubNav
    label="Messaging"
    items={[
      { to: '/messaging', label: 'Overview', end: true },
      { to: '/messaging/messages', label: 'Messages' },
      { to: '/messaging/triggers', label: 'Triggers' },
      { to: '/messaging/templates', label: 'Templates' },
    ]}
  />
);

export default MessagingNav;
